// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-connect-web v0.11.0 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/device_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddRequest, AddResponse, AdminProvisionRequest, AdminProvisionResponse, AdminUnProvisionRequest, AdminUnProvisionResponse, DeleteRequest, DeleteResponse, GetADLDeviceEventsRequest, GetADLDeviceEventsResponse, GetDeviceActivityLevelHistoryRequest, GetDeviceActivityLevelHistoryResponse, GetDeviceByIDRequest, GetDeviceByIDResponse, GetDeviceByProductNameRequest, GetDeviceByProductNameResponse, GetRequest, GetResponse, ListRequest, ListResponse, ProvisionPodWithHubIdRequest, ProvisionPodWithHubIdResponse, ProvisionRequest, ProvisionResponse, ProvisionWithIdRequest, ProvisionWithIdResponse, SendCancelRecordingDeviceCommandRequest, SendCancelRecordingDeviceCommandResponse, SendConfirmFallCommandRequest, SendConfirmFallCommandResponse, SendDeviceCommandRequest, SendDeviceCommandResponse, SendRebootCommandRequest, SendRebootCommandResponse, SendStartGroupRecordingDeviceCommandRequest, SendStartGroupRecordingDeviceCommandResponse, SendStartRecordingDeviceCommandRequest, SendStartRecordingDeviceCommandResponse, SendStopRecordingDeviceCommandRequest, SendStopRecordingDeviceCommandResponse, UnProvisionRequest, UnProvisionResponse, UpdateLabelRequest, UpdateLabelResponse, UpdateRequest, UpdateResponse } from "./device_manager_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * This interface is used only by the backend. It should never be used by users.
 * Intead, the rpc on the device resource shoud be used.
 *
 * @generated from service msh.service.v1.DeviceManager
 */
export const DeviceManager = {
  typeName: "msh.service.v1.DeviceManager",
  methods: {
    /**
     * Creates a device
     * This is called from IOT Core and should not be called
     * in any other context
     *
     * @generated from rpc msh.service.v1.DeviceManager.Add
     */
    add: {
      name: "Add",
      I: AddRequest,
      O: AddResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a device
     * This is called from IOT Core and should not be called
     * in any other context
     *
     * @generated from rpc msh.service.v1.DeviceManager.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteRequest,
      O: DeleteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates a device
     * This is called from IOT Core and should not be called
     * in any other context
     *
     * @generated from rpc msh.service.v1.DeviceManager.Update
     */
    update: {
      name: "Update",
      I: UpdateRequest,
      O: UpdateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates device label
     *
     * @generated from rpc msh.service.v1.DeviceManager.UpdateLabel
     */
    updateLabel: {
      name: "UpdateLabel",
      I: UpdateLabelRequest,
      O: UpdateLabelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Provisions the device to an account/structure
     * The call will fail if the device is already provisionned to another account
     *
     * @generated from rpc msh.service.v1.DeviceManager.Provision
     */
    provision: {
      name: "Provision",
      I: ProvisionRequest,
      O: ProvisionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Provisions the device to an account/structure
     * The call will fail if the device is already provisionned to another account
     *
     * @generated from rpc msh.service.v1.DeviceManager.ProvisionWithId
     */
    provisionWithId: {
      name: "ProvisionWithId",
      I: ProvisionWithIdRequest,
      O: ProvisionWithIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Provisions pod device using the iot_device_id of the hub
     * The call will fail if the device is already provisionned to another account
     *
     * @generated from rpc msh.service.v1.DeviceManager.ProvisionPodWithHubId
     */
    provisionPodWithHubId: {
      name: "ProvisionPodWithHubId",
      I: ProvisionPodWithHubIdRequest,
      O: ProvisionPodWithHubIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Provisions the device to an account/structure without the public key
     * The call will fail if the device is already provisionned to another account
     *
     * @generated from rpc msh.service.v1.DeviceManager.AdminProvision
     */
    adminProvision: {
      name: "AdminProvision",
      I: AdminProvisionRequest,
      O: AdminProvisionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * UnProvisions the device to an account/structure
     * The call will fail if the device is not provisionned or it belongs
     * to another structure
     *
     * @generated from rpc msh.service.v1.DeviceManager.UnProvision
     */
    unProvision: {
      name: "UnProvision",
      I: UnProvisionRequest,
      O: UnProvisionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Unprovisions the device to an account/structure without account check
     *
     * @generated from rpc msh.service.v1.DeviceManager.AdminUnProvision
     */
    adminUnProvision: {
      name: "AdminUnProvision",
      I: AdminUnProvisionRequest,
      O: AdminUnProvisionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Return a simple device (for test for now)
     *
     * @generated from rpc msh.service.v1.DeviceManager.Get
     */
    get: {
      name: "Get",
      I: GetRequest,
      O: GetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Return a device
     *
     * @generated from rpc msh.service.v1.DeviceManager.GetDeviceByID
     */
    getDeviceByID: {
      name: "GetDeviceByID",
      I: GetDeviceByIDRequest,
      O: GetDeviceByIDResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List device for a parent id. Paginated
     *
     * @generated from rpc msh.service.v1.DeviceManager.List
     */
    list: {
      name: "List",
      I: ListRequest,
      O: ListResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.DeviceManager.SendDeviceCommand
     * @deprecated
     */
    sendDeviceCommand: {
      name: "SendDeviceCommand",
      I: SendDeviceCommandRequest,
      O: SendDeviceCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.DeviceManager.SendRebootCommand
     */
    sendRebootCommand: {
      name: "SendRebootCommand",
      I: SendRebootCommandRequest,
      O: SendRebootCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Send a confirm fall command to debug
     *
     * @generated from rpc msh.service.v1.DeviceManager.SendConfirmFallCommand
     */
    sendConfirmFallCommand: {
      name: "SendConfirmFallCommand",
      I: SendConfirmFallCommandRequest,
      O: SendConfirmFallCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Start a raw data recording on a device
     *
     * @generated from rpc msh.service.v1.DeviceManager.SendStartRecordingDeviceCommand
     */
    sendStartRecordingDeviceCommand: {
      name: "SendStartRecordingDeviceCommand",
      I: SendStartRecordingDeviceCommandRequest,
      O: SendStartRecordingDeviceCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stop a raw data recording on a device
     *
     * @generated from rpc msh.service.v1.DeviceManager.SendStopRecordingDeviceCommand
     */
    sendStopRecordingDeviceCommand: {
      name: "SendStopRecordingDeviceCommand",
      I: SendStopRecordingDeviceCommandRequest,
      O: SendStopRecordingDeviceCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancel a raw data recording on a device
     *
     * @generated from rpc msh.service.v1.DeviceManager.SendCancelRecordingDeviceCommand
     */
    sendCancelRecordingDeviceCommand: {
      name: "SendCancelRecordingDeviceCommand",
      I: SendCancelRecordingDeviceCommandRequest,
      O: SendCancelRecordingDeviceCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Start a raw data recording for multiple devices
     *
     * @generated from rpc msh.service.v1.DeviceManager.SendStartGroupRecordingDeviceCommand
     */
    sendStartGroupRecordingDeviceCommand: {
      name: "SendStartGroupRecordingDeviceCommand",
      I: SendStartGroupRecordingDeviceCommandRequest,
      O: SendStartGroupRecordingDeviceCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Start a raw data recording on a device
     *
     * @generated from rpc msh.service.v1.DeviceManager.GetADLDeviceEvents
     */
    getADLDeviceEvents: {
      name: "GetADLDeviceEvents",
      I: GetADLDeviceEventsRequest,
      O: GetADLDeviceEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.DeviceManager.GetDeviceActivityLevelHistory
     */
    getDeviceActivityLevelHistory: {
      name: "GetDeviceActivityLevelHistory",
      I: GetDeviceActivityLevelHistoryRequest,
      O: GetDeviceActivityLevelHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Return a device for a product name
     *
     * @generated from rpc msh.service.v1.DeviceManager.GetDeviceByProductName
     */
    getDeviceByProductName: {
      name: "GetDeviceByProductName",
      I: GetDeviceByProductNameRequest,
      O: GetDeviceByProductNameResponse,
      kind: MethodKind.Unary,
    },
  }
};

